
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetosataracabbooking() {



    const cardData =
    {
        keyword: 'Pune To Satara Cab Booking',
        heading: 'Mauli Cabs: Pune To Satara Cab Booking',
        headingDescription: 'Mauli Cabs offers convenient and reliable Pune to Satara cab booking services, ensuring a smooth and comfortable journey to the historic city of Kolhapur. Whether you are traveling for religious purposes, cultural exploration, or a family trip, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Kolhapur.',

        top: 'Top Places to Visit in Satara with Mauli Cabs',

"topPlaces": [
    {
        "title": "Kaas Plateau (Kaas Pathar)",
        "description": "Kaas Plateau, also known as Kaas Pathar, is a UNESCO World Heritage Site located near Satara. It is famous for its stunning biodiversity, especially the vibrant wildflowers that bloom during the monsoon season, making it a popular spot for nature lovers."
    },
    {
        "title": "Rajwada",
        "description": "Rajwada is a historic palace located in Satara, built during the Maratha period. It reflects the grandeur of the Maratha Empire and showcases impressive architecture and design, making it a must-visit for history enthusiasts."
    },
    {
        "title": "Thoseghar Waterfall",
        "description": "Thoseghar Waterfall, located near Satara, is a scenic waterfall that offers a peaceful retreat amidst nature. The waterfall is known for its grandeur, especially during the monsoon season, and is a perfect spot for picnics and photography."
    },
    {
        "title": "Sajjangad Fort",
        "description": "Sajjangad Fort, located near Satara, is a famous pilgrimage site dedicated to the saint Samarth Ramdas. The fort offers panoramic views of the surrounding region and is a peaceful retreat for those seeking spiritual solace."
    },
    {
        "title": "Koyna Dam",
        "description": "Koyna Dam, situated near Satara, is one of the largest dams in India and an important source of hydroelectric power. The surrounding area is lush and green, making it a great spot for nature lovers and photography enthusiasts."
    },
    {
        "title": "Yogeshwari Temple",
        "description": "Yogeshwari Temple is a revered Hindu temple dedicated to Goddess Yogeshwari, located near Satara. The temple is an important spiritual center, and its location offers a tranquil atmosphere for devotees and visitors alike."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall is a stunning waterfall located near Satara, surrounded by lush forests. It offers beautiful views and a serene atmosphere, making it an ideal place for hiking and nature walks."
    },
    {
        "title": "Chandoli National Park",
        "description": "Chandoli National Park, located near Satara, is part of the Sahyadri Range and is known for its rich biodiversity. It is home to various species of flora and fauna, including tigers, making it a great spot for wildlife enthusiasts and nature lovers."
    },
    {
        "title": "Koynanagar",
        "description": "Koynanagar, located near the Koyna Dam, is a scenic town known for its lush green surroundings, water bodies, and peaceful atmosphere. It is an ideal destination for those looking for a quiet getaway and a connection with nature."
    },
    {
        "title": "Bamnoli Village",
        "description": "Bamnoli Village, located near Satara, is a serene village known for its beautiful lakeside views and adventure activities such as boating and trekking. It’s a great place to relax and enjoy the natural beauty of the surroundings."
    }
],

"services": [
    {
        "name": "Pune to Satara Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable cab services from Pune to Satara. Whether for leisure or business, enjoy a smooth and enjoyable journey to this historic city."
    },
    {
        "name": "Book Pune to Satara Taxi",
        "description": "Book your taxi from Pune to Satara with Mauli Cabs. We offer easy online booking for a hassle-free and comfortable ride to Satara."
    },
    {
        "name": "Affordable Pune to Satara Cab",
        "description": "Mauli Cabs provides affordable taxi services from Pune to Satara. Enjoy competitive pricing without compromising on comfort or quality."
    },
    {
        "name": "Private Taxi for Satara from Pune",
        "description": "Travel privately to Satara from Pune with Mauli Cabs. Our personalized taxi services ensure that you travel in comfort and style, making your journey stress-free."
    },
    {
        "name": "Satara Trip by Cab from Pune",
        "description": "Mauli Cabs offers convenient and comfortable taxi services for your trip from Pune to Satara. Explore the city's historical landmarks with ease and comfort."
    },
    {
        "name": "Pune to Satara One-Way or Round Trip",
        "description": "Mauli Cabs provides flexible one-way and round-trip taxi services from Pune to Satara. Choose the option that best suits your schedule and travel needs."
    },
    {
        "name": "Comfortable Taxi Ride to Satara",
        "description": "Travel in comfort with Mauli Cabs' well-maintained fleet of vehicles. Enjoy a smooth and relaxing taxi ride from Pune to Satara, perfect for both solo and group travelers."
    },
    {
        "name": "Group Travel to Satara",
        "description": "Mauli Cabs offers spacious vehicles for group travel to Satara. Whether you're traveling with friends or family, enjoy the journey together in comfort."
    },
    {
        "name": "Luxury Taxi for Satara Trip",
        "description": "Experience luxury while traveling to Satara from Pune with Mauli Cabs. Our premium taxi services ensure that you enjoy a comfortable and stylish ride."
    },
    {
        "name": "Satara Sightseeing by Taxi",
        "description": "Mauli Cabs offers sightseeing taxi services in Satara. Visit the city's attractions, including historic landmarks and scenic locations, in a comfortable and convenient taxi."
    }
],

"tableData": [
    ["Pune to Satara Cab Service", "Book Pune to Satara Taxi"],
    ["Affordable Pune to Satara Cab", "Private Taxi for Satara from Pune"],
    ["Satara Trip by Cab from Pune", "Pune to Satara One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Satara", "Group Travel to Satara"],
    ["Luxury Taxi for Satara Trip", "Satara Sightseeing by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs provides reliable and timely service for your Pune to Satara Cab Booking. Our experienced drivers ensure prompt pickups and drop-offs, helping you make the most of your time during your journey to Satara."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Satara trip, we offer a range of comfortable vehicles, including sedans, SUVs, and premium cars. All vehicles are air-conditioned, spacious, and well-maintained, ensuring a smooth and pleasant ride throughout the journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are well-versed with the best routes to Satara. They ensure a smooth, safe, and efficient journey, making your trip to Satara a stress-free and enjoyable experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Satara Cab Booking. We ensure that there are no hidden charges, so you can enjoy your trip with the peace of mind that you’re getting the best value for your money."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure your safety and comfort during your trip from Pune to Satara."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Satara journey. Whether you require an early morning ride or a late-night return, our customer service team is always available to assist you with booking your cab at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Satara cab with Mauli Cabs is simple and hassle-free. You can easily book online via our website or mobile app, or contact our customer service team for personalized assistance and seamless booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Satara trip. Whether you're visiting the historic Kas Plateau, the famous Satara fort, or just enjoying the scenic beauty, we can tailor the journey to suit your preferences."
    }
]

















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Satara with Mauli Cabs?',
            answer: 'Booking your cab from Pune to Satara is easy! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Satara as your destination, then select the vehicle that suits your needs. Alternatively, you can call our customer support team for booking assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Satara trip?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options for your trip to Satara. You can choose the vehicle based on your group size, comfort preferences, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Satara trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. The total fare is provided upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Satara take?',
            answer: 'The journey from Pune to Satara typically takes around 3 to 4 hours, depending on traffic and road conditions. Our drivers ensure a smooth and timely journey, making the trip as comfortable as possible.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Satara route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Satara route. They are familiar with the best routes, ensuring a safe and comfortable journey to Satara.',
        },
        {
            question: 'Can I book a round trip from Pune to Satara?',
            answer: 'Yes, you can easily book a round trip to Satara. Just provide your return details when making the booking, and we will ensure a smooth and timely return journey to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Satara?',
            answer: 'Yes, you can customize your trip by making stops for sightseeing along the way. Whether you want to visit nearby attractions or take a short break, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride to Satara.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy via our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Satara trip?',
            answer: 'Mauli Cabs offers professional service, competitive pricing, a range of vehicle options, and experienced drivers. We ensure that your journey to Satara is comfortable, safe, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Raghav Joshi",
            position: "Frequent Traveler",
            text: "I had a fantastic trip to Satara with Mauli Cabs. The vehicle was clean, comfortable, and well-maintained, and the driver was friendly and knowledgeable. The journey was smooth, and I had a pleasant experience. Highly recommend Mauli Cabs for anyone traveling to Satara!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Aishwarya Mehta",
            position: "Weekend Traveler",
            text: "Mauli Cabs made our trip to Satara extremely enjoyable. The driver was polite, and the ride was very comfortable. We enjoyed the scenic beauty along the way, and the car was perfect for the journey. Would definitely book with them again for our next trip!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Satara Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Satara. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to Satara with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
     
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Satara Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Satara cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Satara cab service, Book Pune to Satara taxi, Affordable Pune to Satara cab, Private taxi for Satara from Pune, Satara trip by cab from Pune, Pune to Satara one-way or round trip, Comfortable taxi ride to Satara, Group travel to Satara, Luxury taxi for Satara trip, Satara sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosataracabbooking;